module.exports = {
  appReady: [{
    key: 'userNavigationStarts',
    name: 'User requests the website'
  }, {
    key: 'requestStart',
    name: 'App request start'
  }, {
    key: 'htmlRequest',
    name: 'HTML Request Start',
  }, {
    key: 'jsReady',
    name: 'JS Ready'
  }, {
    key: 'userObjectReady',
    name: 'User object ready'
  }, {
    key: 'fullUserObjectReady',
    name: 'Full user object ready'
  }],
  datacaptureReady: [{
    key: 'siteSelected',
    name: 'User selected a site'
  }, {
    key: 'datacaptureDataReady',
    name: 'Data Capture Data Ready'
  }, {
    key: 'mapReady',
    name: 'Map Ready'
  }],
  pdfReady: [{
    key: 'pdfRequest',
    name: 'User requested a PDF'
  }, {
    key: 'pdfReady',
    name: 'User PDF is ready'
  }],
  shareSite: [{
    key: 'shareSiteRequest',
    name: 'User requested a share link'
  }, {
    key: 'shareSiteReady',
    name: 'The share site link is ready'
  }],
  datasetManagerReady: [{
    key: 'datasetManagerNavigate',
    name: '[Dataset Manager] Navigate'
  }, {
    key: 'datasetManagerDataReady',
    name: '[Dataset Manager] Ready'
  }]
};



// WEBPACK FOOTER //
// ./src/common/technicalkpis/kpiConfig.js